import * as React from "react"
import { keyframes } from "@emotion/react"
import { useTheme, Skeleton } from "@mui/material"

import { isLoadingCommonFilters } from "@signals"
import { AdminProductReviewBaseTable } from "../@components"
import { adminProductReviewRawTableData } from "../@signals"


export default function AdminProductReviewRawTable() {
	const { palette } = useTheme()

	if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={500} />
	if (!adminProductReviewRawTableData.value?.length) return <></>

	return <AdminProductReviewBaseTable
		id='raw-table'
		title="Raw Products and Associated SKUs"
		subtitle="List of raw products and the SKU it has been associated with."
		data={adminProductReviewRawTableData.value}
		options={{
			enhancedSetRowProps: () => ({ sx: {
				"&:has(.is-loading)": {
					animation: `${keyframes({
						"0%": { backgroundColor: palette.info.light },
						"100%": { backgroundColor: palette.info.lighter }
					})} 1s linear infinite alternate`
				},
				"&:has(.is-open)": {backgroundColor: "warning.light"},
				"&:has(.is-open-num-items)": { backgroundColor:  `${palette.warning.lighter} !important` }
			} }),
		}}
	/>
}